import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FunctionComponent } from 'react';
import { RawAnchor } from '../../components/anchor';
import { ExternalLinkIcon } from '../../components/svgs';
import { Text } from '../../components/text';
import type { PolicyCategoryFragment } from '../../graphql/fragments/PolicyCategoryFragment.graphql';
import { useUIStore } from '../../lib/store/useUIStore';
import { LINK } from '../../shared/util/link';
import styles from './policy-category.module.scss';
export const PolicyCategory: FunctionComponent<Props> = ({
  policies,
  title,
  variant = 'default'
}) => {
  const router = useRouter();
  const {
    webview
  } = useUIStore();
  return <div className={classNames(styles['policy-category'], styles[`policy-category--${variant}`])} data-sentry-component="PolicyCategory" data-sentry-source-file="policy-category.tsx">
            <Text typeStyle={variant === 'sidebar' ? 'body-lg' : {
      _: 'body-lg',
      md: 'body-xl'
    }} className={styles['list-heading']} data-sentry-element="Text" data-sentry-source-file="policy-category.tsx">
                {title}
            </Text>
            <ul className={styles.list}>
                {policies?.items?.map(({
        externalLink,
        title,
        slug,
        body
      }) => {
        const link = LINK.policy(slug, webview.isWebview);
        const href = link.serialize(router);
        const titleText = <Text key={slug} tag='span' typeStyle={variant === 'sidebar' ? 'body-lg' : {
          _: 'body-lg',
          md: 'body-xl'
        }} className={styles['list-item--title']}>
                            {title}
                        </Text>;
        const isPDF = body?.type === 'PolicyAttachment' && body?.attachment?.contentType === 'application/pdf';
        return <li className={classNames(styles['list-item'])} key={slug}>
                            {isPDF || externalLink ? <div className={styles['icon-link']}>
                                    <RawAnchor href={externalLink ?? href} target='_blank' rel='noreferrer noopener'>
                                        {titleText}
                                    </RawAnchor>
                                    {externalLink && <ExternalLinkIcon size={21} />}
                                </div> : <Link href={href}>{titleText}</Link>}
                        </li>;
      })}
            </ul>
        </div>;
};
export default PolicyCategory;
interface Props extends Omit<PolicyCategoryFragment, 'sys' | 'type'> {
  variant?: 'default' | 'sidebar';
}